import { EventEmitter } from '@angular/core';
import { Menu } from './menu';
import { MenuItem } from './menu-item';
import { Settings } from '../../../core/config/settings.service';
import { AppearanceEditor } from '../appearance-editor/appearance-editor.service';
import { moveItemInArray } from '@angular/cdk/drag-drop';
import * as i0 from "@angular/core";
import * as i1 from "../../../core/config/settings.service";
import * as i2 from "../appearance-editor/appearance-editor.service";
var MenuEditor = /** @class */ (function () {
    /**
     * MenuEditor Constructor.
     */
    function MenuEditor(settings, appearance) {
        this.settings = settings;
        this.appearance = appearance;
        this.allMenus = [];
        /**
         * Fired when active menu items change (added or deleted).
         */
        this.itemsChange = new EventEmitter();
    }
    /**
     * Get all existing menus.
     */
    MenuEditor.prototype.getAll = function () {
        return this.allMenus;
    };
    /**
     * Create a new menu.
     */
    MenuEditor.prototype.create = function () {
        this.activeMenu = new Menu({ name: 'New Menu' });
        this.allMenus.push(this.activeMenu);
        this.commitChanges();
    };
    /**
     * Reorder currently active menu items to specified order.
     */
    MenuEditor.prototype.reorderActiveMenuItems = function (previousIndex, currentIndex) {
        moveItemInArray(this.activeMenu.items, previousIndex, currentIndex);
        this.commitChanges();
    };
    /**
     * Delete currently active menu.
     */
    MenuEditor.prototype.deleteActive = function () {
        var i = this.allMenus.indexOf(this.activeMenu);
        this.allMenus.splice(i, 1);
        this.activeMenu = null;
        this.commitChanges();
    };
    /**
     * Add new menu item to currently active menu.
     */
    MenuEditor.prototype.addItem = function (item) {
        item = this.transformLocalLinksToRoutes(item);
        this.activeMenu.items.push(item);
        this.commitChanges();
        this.itemsChange.emit();
    };
    /**
     * Transform links to routes if they point to the app.
     */
    MenuEditor.prototype.transformLocalLinksToRoutes = function (item) {
        var baseUrl = this.settings.getBaseUrl();
        if (item.type !== 'link' || item.action.indexOf(baseUrl) === -1)
            return item;
        item.type = 'route';
        item.action = item.action.replace(this.settings.getBaseUrl(), '');
        return item;
    };
    /**
     * Remove specified menu item from currently active menu.
     */
    MenuEditor.prototype.deleteMenuItem = function (item) {
        var i = this.activeMenu.items.indexOf(item);
        this.activeMenu.items.splice(i, 1);
        this.commitChanges();
        this.itemsChange.emit();
    };
    /**
     * Commit current changes to menus.
     */
    MenuEditor.prototype.commitChanges = function () {
        var menus = JSON.stringify(this.allMenus);
        this.appearance.changes.add('menus', menus);
        this.appearance.setConfig('menus', menus);
    };
    /**
     * Set menus from json string.
     */
    MenuEditor.prototype.setFromJson = function (json) {
        if (!json)
            return;
        var menus = JSON.parse(json);
        if (!menus)
            return;
        this.allMenus = menus.map(function (menuData) {
            var menu = new Menu(menuData);
            menu.items = menu.items.map(function (item) { return new MenuItem(item); });
            return menu;
        });
    };
    MenuEditor.ngInjectableDef = i0.defineInjectable({ factory: function MenuEditor_Factory() { return new MenuEditor(i0.inject(i1.Settings), i0.inject(i2.AppearanceEditor)); }, token: MenuEditor, providedIn: "root" });
    return MenuEditor;
}());
export { MenuEditor };
